import { render } from "./Trainings.vue?vue&type=template&id=6e8f1b85&scoped=true"
import script from "./Trainings.vue?vue&type=script&lang=js"
export * from "./Trainings.vue?vue&type=script&lang=js"

import "./Trainings.vue?vue&type=style&index=0&id=6e8f1b85&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8f1b85"]])

export default __exports__